import { Chip } from '@mui/material';
import styled from 'styled-components';
import { IWorflowStepType } from '@modules/admin/AdminTools/QueueConfiguration/types';

export const MenuWorkflowChip = styled(Chip)<{ type: string }>(
    ({ type }) => `
    min-width: 100%;
    justify-content: space-between;
    margin-bottom: 4px;
    font-weight: ${type === IWorflowStepType.Workflow ? 700 : 400};
  `);
  